export default [
  {
    title: 'Dashboard',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'Membership',
        route: 'membership-db',
        icon: 'CircleIcon',
        action: 'access-membership-dashboard',
        resource: 'dashboard',
      },
      {
        title: 'Contribution',
        route: 'contribution-db',
        icon: 'CircleIcon',
        action: 'access-contribution-dashboard',
        resource: 'dashboard',
      },
      {
        title: 'Documents',
        route: 'documents-db',
        icon: 'CircleIcon',
        action: 'access-documents-dashboard',
        resource: 'dashboard',
      },
    ],
  },
  {
    title: 'Administration',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Union',
        route: 'company',
        icon: 'CircleIcon',
        action: 'access-company',
        resource: 'administration',
      },
      {
        title: 'Societies',
        route: 'organizations',
        icon: 'CircleIcon',
        action: 'access-organizations',
        resource: 'administration',
      },
      {
        title: 'Users',
        route: 'users',
        icon: 'CircleIcon',
        action: 'access-users',
        resource: 'administration',
      },
      {
        title: 'Numberings',
        route: 'numberings',
        icon: 'CircleIcon',
        action: 'access-numberings',
        resource: 'administration',
      },
    ],
  },
  {
    title: 'Employee Centre',
    icon: 'BriefcaseIcon',
    children: [
      {
        title: 'Employees',
        route: 'employees',
        icon: 'CircleIcon',
        action: 'access-employees',
        resource: 'employee-centre',
      },
      {
        title: 'Departments',
        route: 'departments',
        icon: 'CircleIcon',
        action: 'access-departments',
        resource: 'employee-centre',
      },
    ],
  },
  {
    title: 'Membership',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Members',
        route: 'members',
        icon: 'CircleIcon',
        action: 'access-members',
        resource: 'membership',
      },
      {
        title: 'ID Customization',
        route: 'id-customization',
        icon: 'CircleIcon',
        action: 'access-id-customization',
        resource: 'membership',
      },
    ],
  },
  {
    title: 'Contribution',
    icon: 'GiftIcon',
    children: [
      {
        title: 'Dues Setup',
        route: 'settings',
        icon: 'CircleIcon',
        action: 'access-contribution-settings',
        resource: 'contribution',
      },
      {
        title: 'Payments & Receipts',
        route: 'payments',
        icon: 'CircleIcon',
        action: 'access-contribution-payments',
        resource: 'contribution',
      },
      {
        title: 'Outstanding Contributions',
        route: 'outstanding',
        icon: 'CircleIcon',
        action: 'access-contribution-payments',
        resource: 'contribution',
      },
      {
        title: 'Grants',
        route: 'grants',
        icon: 'CircleIcon',
        action: 'access-grants',
        resource: 'contribution',
      },
    ],
  },
  {
    title: 'Farm Manager',
    icon: 'MapIcon',
    children: [
      {
        title: 'Farms',
        route: 'farms',
        icon: 'CircleIcon',
        action: 'access-farms',
        resource: 'farm-manager',
      },
      {
        title: 'Production',
        route: 'production',
        icon: 'CircleIcon',
        action: 'access-production',
        resource: 'farm-manager',
      },
    ],
  },
  {
    title: 'Documents',
    icon: 'BookIcon',
    children: [
      {
        title: 'Folders',
        route: 'folders',
        icon: 'CircleIcon',
        action: 'access-folders',
        resource: 'documents',
      },
      {
        title: 'Trash Store',
        route: 'trash',
        icon: 'CircleIcon',
        action: 'access-trash-store',
        resource: 'documents',
      },
    ],
  },
]
